import React from 'react';
import styled from 'styled-components';

type LoadingPulseProps = {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
};

const sizeMap: Record<NonNullable<LoadingPulseProps['size']>, string> = {
  sm: '0.5rem',
  md: '0.75rem',
  lg: '1rem',
};

const Dot = styled.span<{ $size: 'sm' | 'md' | 'lg'; $delay: number }>`
  width: ${({ $size }) => sizeMap[$size]};
  height: ${({ $size }) => sizeMap[$size]};
  border-radius: 50%;
  display: inline-flex;
  background: linear-gradient(145deg, var(--color-accent-light), var(--color-accent-gradient-end));
  box-shadow: var(--shadow-accent);
  animation: pulseGlow 0.9s var(--transition-smooth) infinite;
  animation-delay: ${({ $delay }) => `${$delay}ms`};
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.5rem 0;
`;

export const LoadingPulse: React.FC<LoadingPulseProps> = ({ label = 'Loading', size = 'md' }) => {
  return (
    <Container role="status" aria-label={label}>
      {[0, 120, 240].map((delay) => (
        <Dot key={delay} $size={size} $delay={delay} aria-hidden="true" />
      ))}
      <span style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}>{label}</span>
    </Container>
  );
};

